import React, { useState, useEffect } from "react";
// import { FaSearch } from "react-icons/fa";
import arrowDown from "../../../assets/svg/arrow-down.svg";
import arrowUp from "../../../assets/svg/arrow-up.svg";
import ModalCloseIcon from "../../../assets/svg/close-modal.svg";
import { useNavigate } from "react-router-dom";
import { apiRequest } from "../../../services/api_services/ApiServices";
import { toast } from "react-toastify";
import CommonSearch from "../../SearchBar";
import axios from "axios";
import { header } from "../../../services/getcookie";
const profileUrl = process.env.REACT_APP_ADMIN_API_URL;
export default function HelpQuestions() {
  const navigate = useNavigate();
  const [faqList, setFaqList] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    getFAQList();
  }, []);

  const getFAQList = async () => {
    try {
      const response = await axios.get(profileUrl + "help?application=Mai", {
        headers: header(),
      });

      if (response.data?.success === true) {
        setFaqList(
          (response.data.data || []).map((item) => ({
            ...item,
            expand: false,
          })),
        );
      } else {
        toast.error(response.data?.message || "Failed to fetch FAQ list");
      }
    } catch (e) {
      console.error("FAQ API error:", e);
      toast.error("Update error");
    }
  };

  const filteredFaqs = faqList.filter(
    (item) =>
      search === "" ||
      item.question?.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <div className="relative min-h-screen bg-[#F8F9FB] flex flex-col items-center px-4 py-6">
      <button
        onClick={() => navigate(-1)}
        className="absolute top-4 right-6 bg-white rounded-full shadow p-2 hover:bg-gray-100"
      >
        <img src={ModalCloseIcon} alt="Close" className="w-8 h-8" />
      </button>

      <h1 className="text-4lg font-semibold text-[#172B4D] font-omny">
        Frequently asked questions
      </h1>
      <p className="text-sm text-[#172B4D] mt-2 font-omny">
        These are the most commonly asked questions about Mawalog suite.
      </p>
      <p className="text-sm text-[#172B4D] font-omny">
        Can’t find what you’re looking for? Chat with our AI
      </p>

      {/* Search
      <div className="relative mt-5 w-[260px]">
        <FaSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
        <input
          type="text"
          placeholder="Search questions..."
          className="w-full pl-10 pr-4 py-2.5 rounded-full border-2 border-[#B8D8FF] focus:outline-none focus:ring-2 focus:ring-blue-400 text-sm"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div> */}
      {/* <CommonSearch /> */}

      <div className="mt-4 w-full max-w-[830px] text-sm text-[#172B4D] font-omny">
        Total questions: {filteredFaqs.length}
      </div>

      <div className="mt-3 w-full max-w-[830px] space-y-3">
        {filteredFaqs.map((item) => (
          <div
            key={item.id}
            onClick={() => {
              setFaqList((prev) =>
                prev.map((faq) =>
                  faq.id === item.id ? { ...faq, expand: !faq.expand } : faq,
                ),
              );
            }}
            className="bg-white rounded-xl px-3 py-2 shadow-sm cursor-pointer"
          >
            <div className="flex items-center justify-between">
              <p
                className={`text-sm items-center justify-between font-omny ${
                  item.expand
                    ? "font-bold text-blue-500"
                    : "font-medium text-[#172B4D]"
                }`}
              >
                {item.question}
              </p>
              <img
                src={item.expand ? arrowUp : arrowDown}
                alt="arrow"
                className="w-3 h-3"
              />
            </div>

            {item.expand && (
              <p className="mt-2 text-sm text-gray-600 leading-relaxed font-omny">
                {item.answer}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
